// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-safety"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M14.498 12.998C16.8935 12.998 19.1026 12.998 21.498 12.998V17.6317C21.498 18.307 21.1572 18.9367 20.5919 19.3061L17.998 21.0005L15.4042 19.3061C14.8389 18.9367 14.498 18.307 14.498 17.6317V12.998Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 6.5L9 3L3 6.5V20L9 17.5M15 6.5L21 4V9M15 6.5V9M9 17.5V3.5M9 17.5L10.5 18.375","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M14.498 12.998C16.8935 12.998 19.1026 12.998 21.498 12.998V17.6317C21.498 18.307 21.1572 18.9367 20.5919 19.3061L17.998 21.0005L15.4042 19.3061C14.8389 18.9367 14.498 18.307 14.498 17.6317V12.998Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapSafetyIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-safety',
    ref,
    icon: element,
  },
));

MapSafetyIcon.displayName = 'MapSafetyIcon';

export default MapSafetyIcon;
